// ── Hat Trick Grid — Analytics helper ────────────────────────────────────────
// Thin wrapper around gtag so all event calls are in one place.
// If GA hasn't loaded (e.g. blocked by ad blocker) calls are silently ignored.

function gtag(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

// ── Puzzle lifecycle ──────────────────────────────────────────────────────────

/** Fired when a player makes their first guess on a puzzle */
export function trackPuzzleStarted({ puzzleNumber, puzzleTitle, isArchive }) {
  gtag('event', 'puzzle_started', {
    puzzle_number: puzzleNumber,
    puzzle_title:  puzzleTitle,
    is_archive:    isArchive,
  });
}

/** Fired when the game ends (all 9 correct or out of guesses) */
export function trackPuzzleCompleted({ puzzleNumber, outcome, correctCount, guessesUsed, score, multiplier, suggestionsOff }) {
  gtag('event', 'puzzle_completed', {
    puzzle_number:   puzzleNumber,
    outcome,                        // 'won' | 'lost'
    correct_count:   correctCount,
    guesses_used:    guessesUsed,
    score,
    multiplier,
    suggestions_off: suggestionsOff,
  });
}

// ── Cell events ───────────────────────────────────────────────────────────────

/** Fired on every correct cell answer */
export function trackCellCorrect({ puzzleNumber, row, col, timeSeconds, streakLength }) {
  gtag('event', 'cell_correct', {
    puzzle_number: puzzleNumber,
    cell:          `${row}${col}`,
    time_seconds:  timeSeconds,
    streak_length: streakLength,
  });
}

/** Fired on every wrong guess */
export function trackCellWrong({ puzzleNumber, row, col }) {
  gtag('event', 'cell_wrong', {
    puzzle_number: puzzleNumber,
    cell:          `${row}${col}`,
  });
}

/** Fired when a hint is used */
export function trackHintUsed({ puzzleNumber, row, col, hintsUsedTotal }) {
  gtag('event', 'hint_used', {
    puzzle_number:    puzzleNumber,
    cell:             `${row}${col}`,
    hints_used_total: hintsUsedTotal,
  });
}

// ── UI interactions ───────────────────────────────────────────────────────────

/** Fired when the share button is tapped */
export function trackScoreShared({ method, puzzleNumber, score }) {
  gtag('event', 'score_shared', {
    method,           // 'native' | 'twitter' | 'whatsapp' | 'clipboard'
    puzzle_number: puzzleNumber,
    score,
  });
}

/** Fired when suggestions toggle is switched before first guess */
export function trackSuggestionsToggled({ suggestionsOff }) {
  gtag('event', 'suggestions_toggled', {
    suggestions_off: suggestionsOff,
  });
}

/** Fired when a player picks an archive date */
export function trackArchiveSelected({ puzzleDate, puzzleTitle }) {
  gtag('event', 'archive_puzzle_selected', {
    puzzle_date:  puzzleDate,
    puzzle_title: puzzleTitle,
  });
}

/** Fired when a score is submitted to the leaderboard */
export function trackLeaderboardSubmitted({ puzzleNumber, score, correctCount }) {
  gtag('event', 'leaderboard_submitted', {
    puzzle_number: puzzleNumber,
    score,
    correct_count: correctCount,
  });
}
